import { Link } from "react-router-dom";
import "../landing.css";

const CONTROLLER = "RAF Rede de Apoio aos Familiares";
const CNPJ = "61.281.627/0001-52";
const ENDERECO = "Rua Basílio Puntel, 500 — Jd. Cardoso, Mailasqui, São Roque/SP, CEP 18143-810";
const CONTATO = "rafsp25@gmail.com";
const FORO = "São Roque/SP";
const UPDATED = "Atualizado em junho de 2026";

const DOCS = {
  privacidade: {
    title: "Política de Privacidade",
    body: (
      <>
        <p>Esta Política de Privacidade descreve como a <b>{CONTROLLER}</b>, controladora da plataforma <b>RotaSaúde</b>, coleta, utiliza, armazena e protege dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 - LGPD).</p>
        <h2>1. Dados que coletamos</h2>
        <ul>
          <li><b>Dados cadastrais:</b> nome, e-mail, telefone e dados da empresa contratante.</li>
          <li><b>Dados operacionais:</b> pacientes, endereços de origem/destino, rotas, veículos, equipe e orçamentos inseridos por você.</li>
          <li><b>Dados de geolocalização:</b> quando o motorista compartilha a localização em tempo real durante uma remoção.</li>
          <li><b>Dados de uso:</b> registros de acesso, logs e cookies (ver Política de Cookies).</li>
        </ul>
        <h2>2. Finalidades do tratamento</h2>
        <p>Utilizamos os dados para prestar o serviço contratado (gestão de orçamentos, rotas, rastreamento e financeiro), processar assinaturas, cumprir obrigações legais e melhorar a plataforma.</p>
        <h2>3. Dados sensíveis e de pacientes</h2>
        <p>Os dados de pacientes inseridos pertencem à empresa contratante, que atua como controladora desses dados; a RotaSaúde os trata como operadora, sob instrução da contratante, adotando medidas de segurança e sigilo.</p>
        <h2>4. Compartilhamento</h2>
        <p>Compartilhamos dados apenas com provedores essenciais (ex.: Google Maps para cálculo de rotas e Mercado Pago para pagamentos) e quando exigido por lei. Não vendemos dados pessoais.</p>
        <h2>5. Segurança e retenção</h2>
        <p>Adotamos criptografia, isolamento por empresa (multi-tenant) e controles de acesso. Os dados são retidos enquanto durar a relação contratual e pelos prazos legais aplicáveis.</p>
        <h2>6. Direitos do titular</h2>
        <p>Você pode solicitar acesso, correção, portabilidade, anonimização ou exclusão de dados pelo e-mail de contato {CONTATO}.</p>
        <h2>7. Contato do encarregado (DPO)</h2>
        <p>{CONTROLLER} — CNPJ {CNPJ} — {ENDERECO} — E-mail: {CONTATO}.</p>
      </>
    ),
  },
  termos: {
    title: "Termos de Uso",
    body: (
      <>
        <p>Estes Termos de Uso regulam o acesso e a utilização da plataforma <b>RotaSaúde</b>, oferecida pela <b>{CONTROLLER}</b>.</p>
        <h2>1. Objeto</h2>
        <p>A RotaSaúde é um sistema SaaS multiempresa para gestão de transporte e remoção de pacientes: orçamentos, rotas, frota, equipe, rastreamento e financeiro.</p>
        <h2>2. Cadastro e conta</h2>
        <p>O contratante é responsável pela veracidade das informações e pela guarda das credenciais de acesso. Cada empresa possui ambiente e dados isolados.</p>
        <h2>3. Período de teste e assinatura</h2>
        <p>Oferecemos 14 dias de teste gratuito. Após o período, o acesso depende de assinatura mensal ativa, processada via Mercado Pago. A falta de pagamento pode suspender o acesso.</p>
        <h2>4. Responsabilidades do usuário</h2>
        <p>O usuário é responsável pelos dados inseridos (incluindo dados de pacientes e motoristas), pelo uso adequado do rastreamento e pelo cumprimento da legislação de transporte de pacientes aplicável.</p>
        <h2>5. Disponibilidade</h2>
        <p>Empenhamo-nos por alta disponibilidade do serviço, podendo haver paradas para manutenção. Cálculos de rota/pedágio dependem de serviços de terceiros (Google Maps).</p>
        <h2>6. Limitação de responsabilidade</h2>
        <p>A RotaSaúde é uma ferramenta de apoio à gestão; decisões operacionais e clínicas são de responsabilidade da empresa contratante.</p>
        <h2>7. Rescisão</h2>
        <p>Você pode cancelar a assinatura a qualquer momento. Dados poderão ser exportados/excluídos conforme a Política de Privacidade.</p>
        <h2>8. Foro</h2>
        <p>Aplica-se a legislação brasileira, elegendo-se o foro da comarca de {FORO}.</p>
      </>
    ),
  },
  confidencialidade: {
    title: "Termo de Confidencialidade e Sigilo (NDA)",
    body: (
      <>
        <p>Este Termo estabelece o compromisso de confidencialidade entre a <b>{CONTROLLER}</b> (RotaSaúde) e a empresa contratante quanto às informações tratadas na plataforma.</p>
        <h2>1. Informações confidenciais</h2>
        <p>Consideram-se confidenciais: dados de pacientes, rotas, geolocalização de motoristas, valores de contratos, orçamentos, dados de convênios/hospitais e quaisquer informações comerciais ou operacionais acessadas.</p>
        <h2>2. Obrigações</h2>
        <ul>
          <li>Manter sigilo absoluto sobre as informações confidenciais.</li>
          <li>Utilizar as informações exclusivamente para a execução do serviço.</li>
          <li>Não divulgar a terceiros sem autorização, salvo obrigação legal.</li>
          <li>Adotar medidas técnicas e organizacionais de segurança.</li>
        </ul>
        <h2>3. Colaboradores e prestadores</h2>
        <p>As obrigações de sigilo estendem-se a colaboradores, prepostos e subcontratados que tenham acesso às informações.</p>
        <h2>4. Vigência</h2>
        <p>O dever de confidencialidade permanece durante a relação contratual e por prazo indeterminado após seu término, quanto às informações sensíveis e de pacientes.</p>
        <h2>5. Penalidades</h2>
        <p>A violação sujeita o infrator às responsabilidades civis e criminais previstas na legislação, incluindo a LGPD.</p>
      </>
    ),
  },
  cookies: {
    title: "Política de Cookies",
    body: (
      <>
        <p>Esta Política explica como a <b>RotaSaúde</b>, operada pela <b>{CONTROLLER}</b>, utiliza cookies e tecnologias semelhantes.</p>
        <h2>1. O que são cookies</h2>
        <p>Cookies são pequenos arquivos armazenados no seu dispositivo para permitir e melhorar o funcionamento da plataforma.</p>
        <h2>2. Tipos de cookies que usamos</h2>
        <ul>
          <li><b>Essenciais:</b> necessários para autenticação e sessão (ex.: manter você logado). Não podem ser desativados.</li>
          <li><b>Preferências:</b> lembram escolhas como consentimento de cookies.</li>
          <li><b>Analíticos:</b> quando aplicável, ajudam a entender o uso para melhorias (sempre respeitando seu consentimento).</li>
        </ul>
        <h2>3. Gerenciamento</h2>
        <p>No primeiro acesso, você pode aceitar todos os cookies ou apenas os necessários. Você também pode gerenciar cookies nas configurações do seu navegador.</p>
        <h2>4. Consentimento</h2>
        <p>Ao continuar navegando após o aviso de cookies, você concorda com esta Política, nos termos da LGPD.</p>
        <h2>5. Contato</h2>
        <p>Dúvidas sobre cookies: {CONTATO}.</p>
      </>
    ),
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.privacidade;
  return (
    <div className="lp lp-legal">
      <header className="lp-header">
        <div className="lp-container lp-header-in">
          <Link to="/" className="lp-logo"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></Link>
          <nav className="lp-nav"><Link className="lp-btn lp-btn-ghost" to="/">Voltar ao site</Link></nav>
        </div>
      </header>
      <div className="lp-container">
        <div className="lp-legal-doc" data-testid={`legal-doc-${doc}`}>
          <h1>{d.title}</h1>
          <div className="upd">{UPDATED} • {CONTROLLER}</div>
          {d.body}
          <Link to="/" className="lp-legal-back" data-testid="legal-back">← Voltar para a página inicial</Link>
        </div>
      </div>
    </div>
  );
}
